import React, { FC, useEffect } from 'react'
import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'

import { useAuth } from 'core/auth'
import { useNft } from 'core/nft/api/useNft'
import { useApiError } from 'shared/hooks'

import { Spin, ImgLoad } from 'components'

import imageDefault from 'assets/default.png'

export const NftList: FC = () => {
    const navigate = useNavigate()

    const {
        methods: { handleError }
    } = useApiError('NftList')
    const {
        loading,
        list,
        empty,
        methods: { getList }
    } = useNft()
    const { account } = useAuth()

    useEffect(() => {
        account && getList(account).catch(handleError)
    }, [account, getList, handleError])

    return (
        <Spin spinning={loading} className="w-full">
            <ListWrapper>
                {!empty &&
                    list.map(({ id, name, image_url }) => (
                        <div className="list-item" key={id} onClick={() => navigate(`/nft/${id}`)}>
                            <div className="img-box">
                                <div className="img-wrap">
                                    <ImgLoad
                                        className="img"
                                        loadingImg={imageDefault}
                                        errorImg={imageDefault}
                                        src={image_url}
                                    />
                                </div>
                            </div>
                            <div className="name-box">
                                <div className="name">{name}</div>
                            </div>
                        </div>
                    ))}
            </ListWrapper>
        </Spin>
    )
}

const ListWrapper = styled.div`
    margin: 36px 0 64px 0;
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, 200px);
    grid-gap: 40px;
    .list-item {
        display: block;
        width: 100%;
        background: #fff;
        box-shadow: 0 7px 16px 0 rgba(222, 222, 222, 0.5);
        cursor: pointer;
        .img-box {
            width: 100%;
            height: 0;
            padding-top: 100%;
            position: relative;
            overflow: hidden;
            .img-wrap {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                width: 100%;
                height: 100%;
                background-position: center;
                background-repeat: no-repeat;
                background-size: contain;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .img {
                width: 100%;
                height: 100%;
                max-width: 100%;
                max-height: 100%;
            }
        }
        .name-box {
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 14px 8px;
            box-sizing: content-box;
            .name {
                font-family: Roboto-Regular;
                font-size: 16px;
                color: #000;
                letter-spacing: 0;
                text-align: center;
                line-height: 18px;
                display: -webkit-box;
                overflow: hidden;
                -webkit-box-orient: vertical;
                line-clamp: 2;
                -webkit-line-clamp: 2;
            }
        }
    }
`
